import styles from './ContactsPage.module.css'
import React, { useEffect, useRef } from "react";
import { YMaps, Map, Placemark } from '@pbe/react-yandex-maps';
import telegramLogo from "../../images/telegramLogo.png";
import whatsappLogo from "../../images/whatsappLogo.png";



export default function ContactsPage() {
  useEffect(() => {
    document.body.classList.add("no-footer");
    return () => document.body.classList.remove("no-footer");
  }, []);
  return (
    <div className={styles.contactsPage}>
      <div className={styles.contacts}>
        <h1 className={styles.contacts__title}>Контакты</h1>
        <div className={styles.contacts__textContainer}>
          <p className={styles.contacts__text}>+ 7 993 983 89 98</p>
        </div>
        <div className={styles.contacts__textContainer}>
          <p className={styles.contacts__text}>+ 7 950 254 70 76</p>
        </div>
        <a href="https://t.me/Pitermobile_ru" className={styles.contacts__textContainer}>
          <img className={styles.contacts__img} src={telegramLogo} alt="" />
          <p className={styles.contacts__text}>t.me/pitermobile_ru</p>
        </a>
        <a href='http://wa.me/79939838998' className={styles.contacts__textContainer}>
          <img className={styles.contacts__img} src={whatsappLogo} alt="" />
          <p className={styles.contacts__text}>wa.me/79939838998</p>
        </a>
        <div className={styles.contacts__textContainer}>
          <p className={styles.contacts__text_adress}>Санкт-Петербург, Лиговский проспект 160Б</p>
        </div>
        <div className={styles.contacts__footer}>
          <p className={styles.contacts__footerLS}>Работаем 24/7</p>
          <p className={styles.contacts__footerRS}>Политика конфиденциальности<br /> Copyright Питер мобиль, 2010-2024</p>
        </div>
      </div>
      <div className={styles.map}>
          <YMaps>
            <Map defaultState={{ center: [59.912142, 30.349800], zoom: 9 }} width={'100%'} height={"100%"}>
              <Placemark geometry={[59.912142, 30.349800]} />
            </Map>
          </YMaps>
        </div>
    </div>
  )
}